/* eslint camelcase: 0 */
/* eslint-disable */

import {
  DELETE_ADDRESS_REQUEST,
  DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAILURE,
  FETCH_PROFILE_DETAILS_SUCCESS,
  FETCH_PROFILE_DETAILS_FAILURE,
  CHANGE_LANGUAGE,
  FETCH_ACCESS_CARD_SUCCESS,
  FETCH_ACCESS_CARD_FAILURE,
  FETCH_CART_SUCCESS,
  FETCH_CART,
  POST_CART,
  POST_CART_SUCCESS,
  POST_CART_FAILURE,
  FETCH_HOME_DATA_SUCCESS,
  FETCH_HOME_DATA_FAILURE,
  FETCH_ACCESS_CARD,
  FETCH_HOME_DATA,
  FETCH_ORG_ALBUMS,
  FETCH_ORG_ALBUMS_SUCCESS,
  REMOVE_ACCESS_CARD_SUCCESS,
  REMOVE_ACCESS_CARD_REQUEST,
  REMOVE_ACCESS_CARDS_BULK_REQUEST,
  REMOVE_ACCESS_CARDS_BULK_SUCCESS,
  REMOVE_ACCESS_CARDS_BULK_FAILURE,
  CLEAR_REMOVAL_BLOCKED_ACCESS_IDS
} from "./actions";

import {
  UPDATE_KIDS_NAME,
  POST_EVENT_ORDER_META_UPDATE_REQ,
  POST_EVENT_ORDER_META_UPDATE_SUCCESS,
  POST_EVENT_ORDER_META_UPDATE_FAILURE,
  GET_PRODUCTS_DATA_FOR_EVENT_REQ,
  GET_PRODUCTS_DATA_FOR_EVENT_SUCCESS,
  GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_SUCCESS,
  GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_FAILURE,
  SET_CURRENT_ACCESS_CARD_STATE,
  CLEAR_PRODUCTS,
  GET_CUSTOMER_OFFERS_REQ,
  GET_CUSTOMER_OFFERS_SUCCESS,
  GET_CUSTOMER_OFFERS_FAILURE,
  GET_ADDRESS_DATA_REQ,
  GET_ADDRESS_DATA_SUCCESS,
  GET_ADDRESS_DATA_FAILURE,
  POST_NEW_ADDRESS_REQ,
  POST_NEW_ADDRESS_SUCCESS,
  POST_NEW_ADDRESS_FAILURE,
  PO_INIT_REQ,
  PO_INIT_SUCCESS,
  PO_INIT_FAILURE,
  UPDATE_ORG_ID_FOR_ACCESS_CARD,
  UPDATE_CHECKOUT_STEPS_DATA,
  UPDATE_SELECTED_CUSTOMER_ADDRESS,
  GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_REQ,
  CLEAR_EXISTING_PO,
  UPDATE_BILLING_ADDRESS_FLAG,
  FETCH_PAYBOX_DATA_SUCCESS,
  CHOOSE_OFFER_TO_APPLY,
  APPLY_OFFER_TO_CART_REQ,
  APPLY_OFFER_TO_CART_SUCCESS,
  APPLY_OFFER_TO_CART_FAILURE,
  GET_PAYMENT_RESULT,
  GET_PAYMENT_RESULT_SUCCESS,
  GET_PAYMENT_RESULT_FAILURE,
  GET_CUSTOMER_PURCHASE_ORDERS_SUCCESS,
  GET_CUSTOMER_PURCHASE_ORDERS_REQ,
  UPDATE_FLAG_SHOW_HIDE_CART_ITEM_UPDATE,
  DOWNLOAD_HD_IN_ORDER_SUCCESS,
  SET_CHECKOUT_REFFERER,
  CLEAR_CHECKOUT_REFFERER,
  SET_CASH_PAYMENT_DETAILS,
  CLEAR_KIDS_NAMES,
  SET_RESET_PASSWORD_DATA,
  GET_OTP_FOR_ACCESS_CARD,
  GET_OTP_FOR_ACCESS_CARD_SUCCESS,
  GET_OTP_FOR_ACCESS_CARD_FAILURE,
  VERIFY_ACCESS_CARD_OTP,
  VERIFY_ACCESS_CARD_OTP_SUCCESS,
  VERIFY_ACCESS_CARD_OTP_FAILURE,
  SET_OTP_VERIFIED_STATUS,
  POST_PO_ADDRESS_REQ,
  POST_PO_ADDRESS_SUCCESS,
  POST_PO_ADDRESS_FAILURE,
  SET_SHIPPING_SAME_AS_BILLING,
  GET_PO_ADDRESS_REQ,
  GET_PO_ADDRESS_SUCCESS,
  GET_PO_ADDRESS_FAILURE,
  FETCH_PAYBOX_DATA_FAILURE
} from "./constants";

export const initialState = {
  accessCardData: null,
  orgsWithAlbums: null,
  addressData: null,
  hasBillingAddress: false,
  profileData: null,
  language: sessionStorage.getItem("pFlanguage") || "en",
  error: null,
  accessCardError: null,
  cartData: null,
  loading: true,
  pendingRemovedAccessCards: {},
  pendingRemovedAccessIds: [],
  removalBlockedAccessIds: [],
  photoCart: null,
  homeAccessData: null,
  products_photoCart: null,
  products: null,
  requiredAddress: null,
  serverResponseCode: null,
  serverReply: null,
  currentAccessCard: null,
  customerPO: null,
  paymentType: null,
  cartLoading: false,
  accessCardOrgId: 0,
  kidsName: null,
  customerOffers: null,
  checkOutStepsData: {
    billingAddressId: null,
    shippingAddressRequired: false,
    shippingAddressId: null,
  },
  billingAddresses: null,
  shippingAddresses: null,
  payboxData: null,
  paymentProvider: null,
  applyOfferData: {},
  applyOfferSuccess: false,
  applyOfferResponse: "",
  applyOfferResult: "",
  productsLoading: false,
  accessCardLoading: false,
  offersLoading: false,
  paymentLoading: false,
  paymentResult: null,
  paymentResultError: null,
  purchaseOrders: null,
  ordersLoading: false,
  showCartItemUpdatedMessage: false,
  checkoutRefferer: null,
  cashPaymentData: null,
  paymentMethod: null,
  poLoading: false,
  resetPasswordForm: null,
  bestOffer: null,
  accessCardOTPFetchStatus: null,
  accessCardOTPFetchError: null,
  accessCardOTPVerificationStatus: null,
  poAddressList: null,
  poAddressCreateData: {},
  sameAsBilling: false,
  orgHasOffers: false,
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADDRESS_DATA_REQ:
      return {
        ...state,
        loading: true,
        serverReply: null,
        serverResponseCode: null
      };

    case GET_ADDRESS_DATA_SUCCESS: {
      const billingAddresses = action.payload.data.results.filter(
        (address) => address.address_type === 1
      );
      const shippingAddresses = action.payload.data.results.filter(
        (address) => address.address_type === 0
      );

      return {
        ...state,
        loading: false,
        addressData: action.payload.data.results,
        serverResponseCode: action.payload.status,
        serverReply: "Address added successfully",
        // If addressData has billingAddress data then update hasBillingAddress flag
        hasBillingAddress: billingAddresses.length > 0,
        billingAddresses: billingAddresses,
        shippingAddresses: shippingAddresses
      };
    }
    case GET_ADDRESS_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        addressData: [],
        serverResponseCode: action.payload.response.status,
        serverReply: action.payload.response.data.custom_response
      };
    case POST_NEW_ADDRESS_REQ:
      return {
        ...state,
        loading: true,
        serverReply: null,
        serverResponseCode: null
      };
    case POST_NEW_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        // addressData: action.payload,
        serverResponseCode: action.payload.request.status,
        serverReply: "Address added successfully"
      };
    case POST_NEW_ADDRESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        serverResponseCode: action.payload.request.status,
        serverReply: action.payload.response.data.custom_response
      };
    case DELETE_ADDRESS_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_ADDRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        addressData: state.addressData.filter(
          (address) => address.id !== action.payload
        )
      };
    case DELETE_ADDRESS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_PROFILE_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload
      };

    case FETCH_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        profileData: action.payload.results[0]
      };
    case GET_CUSTOMER_OFFERS_REQ:
      return {
        ...state,
        customerOffers: [],
        loading: true,
        serverReply: null,
        serverResponseCode: null,
        offersLoading: true
      };
    case GET_CUSTOMER_OFFERS_SUCCESS: {
      const {
        eventCustomerOffers,
        orgCustomerOffers,
        orgOffers,
        best_offer_id_for_customer: bestCustomerOfferId
      } = action.payload?.data || {};

      let combinedOffers = [];

      // Check if user is logged in by checking eventCustomerOffers and orgCustomerOffers
      if (eventCustomerOffers && orgCustomerOffers) {
        const eventOffersCustomer = Object.values(eventCustomerOffers).flat();
        const orgOffersCustomer = Object.values(orgCustomerOffers).flat();
        combinedOffers = [...eventOffersCustomer, ...orgOffersCustomer];
      } else if (orgOffers) {
        // If user is not logged in, use OrgOffers
        combinedOffers = orgOffers; // Assuming OrgOffers is an array
      }

      if (combinedOffers.length > 0) {
        state.orgHasOffers = true;
      }

      return {
        ...state,
        customerOffers: combinedOffers,
        loading: false,
        offersLoading: false,
        bestOffer: bestCustomerOfferId ?? null,
        // serverResponseCode: action.payload.status,
        // serverReply: "Offers fetched successfully"
      };
    }
    case GET_CUSTOMER_OFFERS_FAILURE:
      console.log("Reducer failure for offers", action);
      return {
        ...state,
        error: action.payload
      };
    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.payload
      };
    case FETCH_ACCESS_CARD:
      return {
        ...state,
        loading: true,
        accessCardError: null,
        accessCardLoading: true
      };
    case FETCH_ACCESS_CARD_SUCCESS:
      return {
        ...state,
        accessCardData: action.payload,
        homeAccessData: action.payload,
        loading: false,
        accessCardLoading: false
      };

    case FETCH_ORG_ALBUMS:
      return {
        ...state,
        loading: true
      };

    case FETCH_ORG_ALBUMS_SUCCESS:
      return {
        ...state,
        loading: false,
        orgsWithAlbums: action.payload
      };
    case FETCH_ACCESS_CARD_FAILURE: {
      return {
        ...state,
        accessCardError: action.payload,
        loading: false
      };
    }
    case UPDATE_KIDS_NAME: {
      const { accessId, field, value, accessCode } = action.payload;
      const accessUid = `${accessId}:${accessCode}`;

      const currentKidsName = state.kidsName || {};
      const currentCheckOutStepsData = state.checkOutStepsData || {};

      const updatedKidsName = {
        ...currentKidsName,
        [accessUid]: {
          ...currentKidsName[accessUid],
          [field]: value
        }
      };

      return {
        ...state,
        kidsName: updatedKidsName,
        checkOutStepsData: {
          ...currentCheckOutStepsData,
          kidsName: updatedKidsName
        }
      };
    }

    case UPDATE_ORG_ID_FOR_ACCESS_CARD:
      return {
        ...state,
        accessCardOrgId: action.payload
      };
    case POST_EVENT_ORDER_META_UPDATE_REQ:
      return {
        ...state,
        loading: true,
        serverReply: null,
        serverResponseCode: null,
        checkOutStepsData: {
          ...state.checkOutStepsData,
          kidsNameAddedSuccess: false
        }
      };
    case POST_EVENT_ORDER_META_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        checkOutStepsData: {
          ...state.checkOutStepsData,
          kidsNameAddedSuccess: true
        },
        // kids_name: action.payload,
        serverResponseCode: action.payload.status,
        serverReply: action.payload.data.custom_response
      };
    case POST_EVENT_ORDER_META_UPDATE_FAILURE:
      return {
        ...state,
        loading: false,
        checkOutStepsData: {
          ...state.checkOutStepsData,
          kidsNameAddedSuccess: false
        }
        // error: action.payload,
        // serverResponseCode: action.payload.response.status,
        // serverReply: action.payload.response.data.custom_response
      };
    case FETCH_CART:
      return {
        ...state,
        cartLoading: true
      };
    case FETCH_CART_SUCCESS:
      return {
        ...state,
        cartData: action.payload.cart,
        photoCart: action.payload.photo_cart,
        shipping_cost: action.payload.shipping_cost,
        fullCart: action.payload,
        cartLoading: false
      };
    case POST_CART:
      return {
        ...state,
        cartLoading: true,
        showCartItemUpdatedMessage: false
      };
    case POST_CART_SUCCESS:
      // console.log("POST_CART_SUCCESS action payload", state.customerPO, action.payload);
      return {
        ...state,
        cartData: action.payload.cart,
        photoCart: action.payload.photo_cart,
        cartLoading: false,
        showCartItemUpdatedMessage: true,
        fullCart: action.payload,
        customerPO: null,
        // customerPO: state.customerPO !== null ? action.payload.customer_po !== null && action.payload.customer_po !== undefined
        //   ? action.payload.customer_po : state.customerPO : state.customerPO
      };
    case POST_CART_FAILURE:
      return {
        ...state,
        cartLoading: false,
        showCartItemUpdatedMessage: true
      };
    case FETCH_HOME_DATA:
      return {
        ...state,
        loading: true,
        accessCardLoading: true,
        accessCardError: null
      };
    case FETCH_HOME_DATA_SUCCESS:
      return {
        ...state,
        homeAccessData: action.payload,
        accessCardData: action.payload,
        loading: false,
        accessCardLoading: false
      };
    case FETCH_HOME_DATA_FAILURE: {
      return {
        ...state,
        accessCardError: action.payload,
        loading: false,
        accessCardLoading: false
      };
    }
    case GET_PRODUCTS_DATA_FOR_EVENT_REQ:
      return {
        ...state,
        productsLoading: true,
        loading: true
      };
    case GET_PRODUCTS_DATA_FOR_EVENT_SUCCESS:
      return {
        ...state,
        eventName: action.data.event.name,
        eventId: action.data.event.id,
        products: action.data.event.products,
        products_photoCart: action.data.event.cart,
        loading: false,
        productsLoading: false
      };
    case GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_REQ:
      return {
        ...state,
        loading: true
      };
    case GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_SUCCESS:
      return {
        ...state,
        requiredAddress: action.payload,
        loading: false
      };
    case GET_REQUIRED_ADDRESS_TYPE_FOR_CUSTOMER_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    case SET_CURRENT_ACCESS_CARD_STATE:
      return {
        ...state,
        currentAccessCard: action.payload
      };
    case CLEAR_PRODUCTS:
      return {
        ...state,
        products: null,
        products_photoCart: null
      };
    case CLEAR_EXISTING_PO:
      return {
        ...state,
        customerPO: null,
        checkOutStepsData: {}
      };
    case PO_INIT_REQ:
      return {
        ...state,
        poLoading: true,
        serverResponseCode: null,
        serverReply: null
      };
    case PO_INIT_SUCCESS:
      return {
        ...state,
        customerPO: action.payload.data.order_no,
        checkOutStepsData: {
          ...state.checkOutStepsData,
          customerPO: action.payload.data
        },
        paymentType: action.payload.data.payment_type,
        poLoading: false
      };
    case PO_INIT_FAILURE:
      return {
        ...state,
        customerPO: "Error creating purchase order",
        error: action.payload
      };
    case UPDATE_CHECKOUT_STEPS_DATA:
      return {
        ...state,
        checkOutStepsData: action.payload
      };
    case UPDATE_SELECTED_CUSTOMER_ADDRESS:
      {
        return {
          ...state,
          checkOutStepsData: {
            ...state.checkOutStepsData,
            ...action.payload
          },
          poAddressCreateData: {
            ...state.poAddressCreateData,
            ...action.payload
          }
        };
      };
    case UPDATE_BILLING_ADDRESS_FLAG:
      return {
        ...state,
        hasBillingAddress: action.payload
      };
    case CHOOSE_OFFER_TO_APPLY:
      return {
        ...state,
        applyOfferData: action.payload
      };
    case APPLY_OFFER_TO_CART_REQ:
      return {
        ...state,
        applyOfferSuccess: false,
        applyOfferResponse: "",
        applyOfferResult: "",
        serverResponseCode: null
        // applyOfferData: {}
      };
    case APPLY_OFFER_TO_CART_SUCCESS: {
      return {
        ...state,
        applyOfferData: action.payload.data,
        applyOfferSuccess: action.payload.data.success,
        applyOfferResponse: action.payload.data.message,
        applyOfferResult: action.payload.data.offer_applied_result,
        cartData: action.payload.data.cart,
        fullCart: action.payload.data,
      };
    }
    case APPLY_OFFER_TO_CART_FAILURE:
      return {
        ...state,
        // applyOfferData: action.payload,
        applyOfferSuccess: false,
        applyOfferResponse: "",
        applyOfferResult: ""
        // serverResponseCode: action.payload.response.status,
      };

    case FETCH_PAYBOX_DATA_SUCCESS:
      // Handle error responses (e.g., lemonway_unavailable)
      if (action.payload.error) {
        return {
          ...state,
          payboxData: action.payload,
          paymentProvider: null
        };
      }
      // Handle duplicate payment case where payment_provider is completed and po_id exists
      if (action.payload.payment_provider === 'completed' && action.payload.po_id) {
        return {
          ...state,
          payboxData: action.payload,
          paymentProvider: action.payload.payment_provider
        };
      }
      // Normal payment flow
      return {
        ...state,
        payboxData: action.payload.payment_data,
        paymentProvider: action.payload.payment_provider
      };

    case FETCH_PAYBOX_DATA_FAILURE:
      return {
        ...state,
        payboxData: null,
        paymentProvider: null,
        error: action.payload
      };

    case GET_PAYMENT_RESULT:
      return {
        ...state,
        paymentLoading: true
      };

    case GET_PAYMENT_RESULT_SUCCESS:
      return {
        ...state,
        paymentLoading: false,
        paymentResult: action.payload.result,
        customerPO: null,
      };

    case GET_PAYMENT_RESULT_FAILURE:
      return {
        ...state,
        paymentLoading: false,
        paymentResultError: action.payload
      };
    case GET_CUSTOMER_PURCHASE_ORDERS_REQ:
      return {
        ...state,
        loading: true,
        ordersLoading: true
      };
    case GET_CUSTOMER_PURCHASE_ORDERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        ordersLoading: false,
        purchaseOrders: action.payload
      };
    }
    case UPDATE_FLAG_SHOW_HIDE_CART_ITEM_UPDATE: {
      return {
        ...state,
        showCartItemUpdatedMessage: action.payload
      };
    }
    case DOWNLOAD_HD_IN_ORDER_SUCCESS: {
      const { order_product_id: orderProductId, photo_links } = action.payload;

      const originalUrls = photo_links ? photo_links.map(link => link.original_url) : [];

      return {
        ...state,
        hdDownloads: {
          ...state.hdDownloads,
          [orderProductId]: originalUrls
        }
      };
    }
    case SET_CHECKOUT_REFFERER:
      return {
        ...state,
        checkoutRefferer: "cart"
      };
    case CLEAR_CHECKOUT_REFFERER:
      return {
        ...state,
        checkoutRefferer: null
      };
    case REMOVE_ACCESS_CARD_SUCCESS:
      return {
        ...state,
        accessCardData: action.payload,
        homeAccessData: action.payload,
        loading: false,
        accessCardLoading: false
      };
    case REMOVE_ACCESS_CARD_REQUEST:
      return {
        ...state,
        loading: true,
        accessCardLoading: true
      };
    case REMOVE_ACCESS_CARDS_BULK_REQUEST: {
      const accessUids = action.payload?.accessUids || [];
      if (!state.accessCardData?.access_ids || accessUids.length === 0) {
        return {
          ...state,
          pendingRemovedAccessCards: {},
          pendingRemovedAccessIds: [],
          removalBlockedAccessIds: []
        };
      }

      const accessIdsToRemove = accessUids.map((uid) =>
        uid && typeof uid === "string" && uid.includes(":") ? uid.split(":")[0] : uid
      );
      const currentAccessIds = state.accessCardData?.access_ids || {};
      const currentHomeAccessIds = state.homeAccessData?.access_ids || {};

      const backup = { ...state.pendingRemovedAccessCards };
      const updatedAccessIds = { ...currentAccessIds };
      const updatedHomeAccessIds = { ...currentHomeAccessIds };

      accessIdsToRemove.forEach((accessId) => {
        if (currentAccessIds[accessId]) {
          backup[accessId] = currentAccessIds[accessId];
          delete updatedAccessIds[accessId];
        }
        if (updatedHomeAccessIds[accessId]) {
          delete updatedHomeAccessIds[accessId];
        }
      });

      return {
        ...state,
        accessCardData: {
          ...state.accessCardData,
          access_ids: updatedAccessIds
        },
        homeAccessData: state.homeAccessData
          ? { ...state.homeAccessData, access_ids: updatedHomeAccessIds }
          : state.homeAccessData,
        pendingRemovedAccessCards: backup,
        pendingRemovedAccessIds: accessIdsToRemove,
        removalBlockedAccessIds: []
      };
    }
    case REMOVE_ACCESS_CARDS_BULK_SUCCESS: {
      const removedUids = action.payload.removed_access_uids || [];
      const requestedUids =
        action.payload.requested_access_uids || state.pendingRemovedAccessIds || [];

      const removedAccessIds = new Set();
      removedUids.forEach((uid) => {
        if (uid && typeof uid === "string" && uid.includes(":")) {
          removedAccessIds.add(uid.split(":")[0]);
        } else if (uid) {
          removedAccessIds.add(uid);
        }
      });

      const requestedAccessIds = requestedUids.map((uid) =>
        uid && typeof uid === "string" && uid.includes(":") ? uid.split(":")[0] : uid
      );

      const notRemovedAccessIds = requestedAccessIds.filter(
        (accessId) => accessId && !removedAccessIds.has(accessId)
      );

      const currentAccessIds = state.accessCardData?.access_ids || {};
      const currentHomeAccessIds = state.homeAccessData?.access_ids || {};

      const remainingAccessIds = {};
      Object.keys(currentAccessIds).forEach((accessId) => {
        if (!removedAccessIds.has(accessId)) {
          remainingAccessIds[accessId] = currentAccessIds[accessId];
        }
      });

      if (notRemovedAccessIds.length > 0) {
        notRemovedAccessIds.forEach((accessId) => {
          if (state.pendingRemovedAccessCards?.[accessId]) {
            remainingAccessIds[accessId] = state.pendingRemovedAccessCards[accessId];
          }
        });
      }

      const remainingHomeAccessIds = {};
      Object.keys(currentHomeAccessIds).forEach((accessId) => {
        if (!removedAccessIds.has(accessId)) {
          remainingHomeAccessIds[accessId] = currentHomeAccessIds[accessId];
        }
      });
      if (notRemovedAccessIds.length > 0) {
        notRemovedAccessIds.forEach((accessId) => {
          if (state.pendingRemovedAccessCards?.[accessId]) {
            remainingHomeAccessIds[accessId] = state.pendingRemovedAccessCards[accessId];
          }
        });
      }

      const allRemoved =
        action.payload.all_removed || Object.keys(remainingAccessIds).length === 0;

      if (allRemoved) {
        return {
          ...state,
          accessCardData: { access_ids: {}, selected_access_uid: null },
          homeAccessData: { access_ids: {}, selected_access_uid: null },
          pendingRemovedAccessCards: {},
          pendingRemovedAccessIds: [],
          removalBlockedAccessIds: notRemovedAccessIds,
          loading: false,
          accessCardLoading: false
        };
      }

      const currentSelectedUid = state.accessCardData?.selected_access_uid;
      let newSelectedUid = currentSelectedUid;
      if (currentSelectedUid) {
        const currentAccessId = currentSelectedUid.split(":")[0];
        if (removedAccessIds.has(currentAccessId)) {
          const firstRemainingId = Object.keys(remainingAccessIds)[0];
          if (firstRemainingId) {
            const firstRemainingCard = remainingAccessIds[firstRemainingId];
            const firstAccessCode = firstRemainingCard?.summary?.access_code;
            newSelectedUid = firstAccessCode ? `${firstRemainingId}:${firstAccessCode}` : null;
          } else {
            newSelectedUid = null;
          }
        }
      }

      return {
        ...state,
        accessCardData: {
          ...state.accessCardData,
          access_ids: remainingAccessIds,
          selected_access_uid: newSelectedUid
        },
        homeAccessData: state.homeAccessData
          ? {
            ...state.homeAccessData,
            access_ids: remainingHomeAccessIds,
            selected_access_uid: newSelectedUid
          }
          : state.homeAccessData,
        pendingRemovedAccessCards: {},
        pendingRemovedAccessIds: [],
        removalBlockedAccessIds: notRemovedAccessIds,
        loading: false,
        accessCardLoading: false
      };
    }
    case REMOVE_ACCESS_CARDS_BULK_FAILURE: {
      const restoredAccessIds = {
        ...(state.accessCardData?.access_ids || {})
      };
      const restoredHomeAccessIds = {
        ...(state.homeAccessData?.access_ids || {})
      };

      Object.keys(state.pendingRemovedAccessCards || {}).forEach((accessId) => {
        restoredAccessIds[accessId] = state.pendingRemovedAccessCards[accessId];
        restoredHomeAccessIds[accessId] = state.pendingRemovedAccessCards[accessId];
      });

      return {
        ...state,
        accessCardData: state.accessCardData
          ? { ...state.accessCardData, access_ids: restoredAccessIds }
          : state.accessCardData,
        homeAccessData: state.homeAccessData
          ? { ...state.homeAccessData, access_ids: restoredHomeAccessIds }
          : state.homeAccessData,
        pendingRemovedAccessCards: {},
        pendingRemovedAccessIds: [],
        removalBlockedAccessIds: [],
        loading: false,
        accessCardLoading: false
      };
    }
    case CLEAR_REMOVAL_BLOCKED_ACCESS_IDS:
      return {
        ...state,
        removalBlockedAccessIds: []
      };
    case SET_CASH_PAYMENT_DETAILS:
      if (!action.payload || Object.keys(action.payload).length === 0) {
        return {
          ...state,
          paymentMethod: "",
          cashPaymentData: null // Reset cash payment data
        };
      }
      return {
        ...state,
        paymentMethod: action?.payload?.formattedAmount === null ? "" : "CASH",
        cashPaymentData: action.payload
      };
    case CLEAR_KIDS_NAMES: {
      const currentCheckOutStepsData = state.checkOutStepsData || {};
      return {
        ...state,
        kidsName: {},
        checkOutStepsData: {
          ...currentCheckOutStepsData,
          kidsName: {}
        }
      };
    }

    case SET_RESET_PASSWORD_DATA:
      return {
        ...state,
        resetPasswordForm: action.payload
      };

    case GET_OTP_FOR_ACCESS_CARD:
      return { ...state, accessCardOTPFetchStatus: "loading", accessCardOTPFetchError: null };

    case GET_OTP_FOR_ACCESS_CARD_SUCCESS:
      return { ...state, accessCardOTPFetchStatus: "success", accessCardOTPFetchError: null };

    case GET_OTP_FOR_ACCESS_CARD_FAILURE:
      console.log("GET OTP FAILED FOR ACCESS CARD", action.payload);
      return { ...state, accessCardOTPFetchStatus: "error", accessCardOTPFetchError: action.payload };

    case VERIFY_ACCESS_CARD_OTP:
      return {
        ...state,
        accessCardOTPVerificationStatus: "loading"
      };

    case VERIFY_ACCESS_CARD_OTP_SUCCESS:
      return {
        ...state,
        accessCardOTPVerificationStatus: "success",
      };

    case VERIFY_ACCESS_CARD_OTP_FAILURE:
      console.log("VERIFU OTP FAILED FOR ACCESS CARD", action.payload);
      return {
        ...state,
        accessCardOTPVerificationStatus: "error",
        accessCardOTPFetchError: action.payload

      };

    case SET_OTP_VERIFIED_STATUS:
      // console.log("Verify otp result here Setting OTP verified status to:", action.payload, state.accessCardOTPVerificationStatus);
      return {
        ...state,
        accessCardOTPVerificationStatus: action.payload
      };

    case POST_PO_ADDRESS_REQ:
      return {
        ...state,
        // poLoading: true,
        serverReply: null,
        serverResponseCode: null
      };
    case POST_PO_ADDRESS_SUCCESS:
      return {
        ...state,
        poAddressCreateData: null
      };
    case POST_PO_ADDRESS_FAILURE:
      return {
        ...state,
        poAddressCreateData: null,
      };
    case GET_PO_ADDRESS_REQ:
      return {
        ...state,
        loading: true,
        poAddressList: null,
        serverResponseCode: null
      };
    case GET_PO_ADDRESS_SUCCESS: {

      const billingAddresses = action.payload.data.results.filter(
        (address) => address.address_type === 1
      );
      const shippingAddresses = action.payload.data.results.filter(
        (address) => address.address_type === 0
      );
      return {
        ...state,
        loading: false,
        addressData: action.payload.data.results,
        serverResponseCode: action.payload.status,
        serverReply: "Address fetched successfully",
        // If addressData has billingAddress data then update hasBillingAddress flag
        hasBillingAddress: billingAddresses.length > 0,
        billingAddresses: billingAddresses,
        shippingAddresses: shippingAddresses,
        sameAsBilling: false, // Reset sameAsBilling when fetching addresses
      };
    }
    case GET_PO_ADDRESS_FAILURE:
      return {
        ...state,
        loading: false,
        poAddressList: [],
      };

    case SET_SHIPPING_SAME_AS_BILLING:
      return {
        ...state,
        sameAsBilling: action.payload
      };

    default:
      return state;
  }
};

export default rootReducer;
